<!-- eslint-disable vue/valid-v-model -->
<template>
  <div
    v-if="formData.entitlementFeature && isFormInited"
    class="wrapper main-form-container"
  >
    <ValidationObserver
      ref="validationObserver"
      v-slot="{ handleSubmit }"
    >
      <form
        class="contact-info"
        novalidate="novalidate"
        @submit.prevent="handleSubmit(submit)"
        @input="handleFormChange"
      >
        <div
          v-if="hasChanges && shouldShowWarning"
          class="warning-message"
        >
          <inline-svg
            :src="iconWarning"
            class="warning-icon"
          ></inline-svg>
          Changes won’t be saved unless you click Apply.
        </div>
        <EntitlementFeatureManagement
          :itemType="collectionType"
          :entitlementFeature="formData.entitlementFeature"
          :onChange="handleEntitlementFeatureChange"
        />

        <div class="action-buttons-wrapper">
          <Button
            title="Revert"
            classType="warning"
            className="without-margin"
            :eventFunction="handleRevertForm"
          />
          <Button
            title="Apply"
            classType="primary"
            type="submit"
            className="without-margin"
          />
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import {
  mapGetters,
} from 'vuex';
import CONFIG from '../../constants/config';
import {
  SET_EDIT_FORM,
} from '../../store/actions/common';

import Button from '../common/Button.vue';
import BaseForm from './BaseForm.vue';
import iconWarning from '../../assets/icons/icon-warning-localization.svg';
import EntitlementFeatureManagement from '../EntitlementFeatureManagement.vue';

export default {
  name: 'CollectionAccessForm',
  components: {
    Button,
    EntitlementFeatureManagement,
  },
  extends: BaseForm,
  props: {
    formPrefix: {
      type: String,
      default: 'metadata',
    },
    collectionType: {
      type: String,
      default: '',
    },
    metadata: {
      type: Object,
      default: () => {},
    },
    submitEventName: {
      type: String,
      required: true,
    },
    submitParams: {
      type: Object,
      default: () => ({}),
    },
    successMessageText: {
      type: String,
      default: '',
    },
    hasChanges: {
      type: Boolean,
      default: false,
    },
    setHasChanges: {
      type: Function,
      default: () => {},
    },
    shouldShowWarning: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      iconWarning,
      submitEvent: this.submitEventName,
      successMessage: this.successMessageText,
      errorMessage: CONFIG.errorMessages.commonServerError,
      isFormInited: false,
      formData: {
        entitlementFeature: null,
      },
    };
  },
  computed: {
    ...mapGetters([
      'getCurrentAccountId',
    ]),
  },
  mounted() {
    this.initFormData();
  },
  methods: {
    initFormData() {
      if (this.metadata.entitlementFeature) {
        this.formData.entitlementFeature = JSON.parse(
          JSON.stringify(this.metadata.entitlementFeature),
        );

        this.isFormInited = true;
      }
    },
    handleEntitlementFeatureChange(data) {
      const { key, value } = data;
      if (this.formData.entitlementFeature[key] === value) return;

      this.formData.entitlementFeature[key] = value;

      this.$store.dispatch(SET_EDIT_FORM, true);
      this.handleFormChange();
    },
    handleRevertForm() {
      this.isFormInited = false;
      this.$store.dispatch(SET_EDIT_FORM, false);
      this.setHasChanges(false);
      this.$emit('resetShouldShowWarning');

      this.$nextTick(() => {
        this.initFormData();
      });
    },
    handleFormChange() {
      this.$store.dispatch(SET_EDIT_FORM, true);
      this.setHasChanges(true);
    },
    getRequestData() {
      const { formData, submitParams } = this;
      const data = {};

      data.entitlementFeature = {
        id: formData.entitlementFeature?.id === '0'
          ? null
          : formData.entitlementFeature?.id,
        isInherited: formData.entitlementFeature?.isInherited,
      };

      submitParams.data = data;

      return submitParams;
    },
    onSubmitFail(error) {
      this.formErrors = this.getServerFormErrors(error);
      this.itemsErrors = this.getServerFormCollectionErrors(error);

      if (Object.entries(this.formErrors).length && this.$refs[this.validationObserver]) {
        this.$refs[this.validationObserver].setErrors(this.formErrors);
      } else {
        this.$toasted.global.error({
          message: this.errorMessage,
        });
      }
    },
    onSubmitSuccess(res) {
      this.$toasted.global.success({
        message: this.successMessage,
      });
      if (res.data?.id === this.metadata.id) {
        this.$emit('handleUpdatedMetadata', res.data);
      } else {
        this.$emit('reloadItem');
      }

      this.$store.dispatch(SET_EDIT_FORM, false);
      this.setHasChanges(false);
      this.$emit('resetShouldShowWarning');
    },
  },
};
</script>

<style scoped>
  .wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .action-buttons-wrapper {
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    margin-top: 20px;
  }
  .warning-message {
    color: #F2C94C;
    gap: 6px;
    display: flex;
    align-items: center;
    padding: 8px 10px;
    border: 1px solid #F2C94C;
    border-radius: 4px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    width: fit-content;
    margin-bottom: 30px;
  }
</style>
